import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popup-contents" }
const _hoisted_2 = { class: "popup-contents-title" }
const _hoisted_3 = { class: "popup-contents-text" }


import Modal from "@/views/base/ModalComponent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Tips',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
function onClose() {
  emit("close");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    id: "healthcaredata02-01-d-modal",
    closable: true,
    showTab: false,
    modalClass: "clinic-note-popup",
    onClose: onClose
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", { class: "modal-header" }, [
        _createElementVNode("button", {
          type: "button",
          class: "modal-close",
          onClick: onClose
        }, _cache[0] || (_cache[0] = [
          _createElementVNode("img", { src: "/server/necs/images/close-btn.png" }, null, -1)
        ]))
      ])
    ]),
    bodyInfo: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("img", {
          class: "popup-contents-img",
          src: "/server/necs/images/clinic_note_popup.png",
          alt: "診察ノート"
        }, null, -1)),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("clinic_note_tips_title")), 1),
        _createElementVNode("p", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.$t("clinic_note_tips_text")) + " ", 1),
          _cache[1] || (_cache[1] = _createElementVNode("br", { class: "sp-only" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("clinic_note_tips_text2")) + " ", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("clinic_note_tips_text3")), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("clinic_note_tips_text4")) + " ", 1),
          _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("clinic_note_tips_text5")), 1)
        ])
      ])
    ]),
    footerButton: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "modal-button-next",
        onClick: onClose
      }, _toDisplayString(_ctx.$t("clinic_note_tips_button_close")), 1)
    ]),
    _: 1
  }))
}
}

})